var map = {
	"./de/btn-download-google-play.png": "Kryd",
	"./en/btn-download-google-play.png": "X2uk",
	"./es/btn-download-google-play.png": "H06p",
	"./fr/btn-download-google-play.png": "MOnj",
	"./ja/btn-download-google-play.png": "mQnx",
	"./ko/btn-download-google-play.png": "CxEC",
	"./pt/btn-download-google-play.png": "1ul9",
	"./ru/btn-download-google-play.png": "kPra",
	"./th/btn-download-google-play.png": "fsNy",
	"./zh-Hant/btn-download-google-play.png": "FBfX"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sNQi";